import { BASE_REST_API_URL } from 'common/constants';
import { type Country, type SerializedUser, UserRole } from '@enmon/commons/lib/enmon';
import { AxiosError } from 'axios';
import { z } from 'zod';
import { formErrorSchema } from 'components/form/error';
import { BaseApiClient } from '../baseApiClient';
import { ValidationFailedError } from '../validation-failed.error';

export interface CreateDemoUserDto {
  name: string;
  email: string;
  country: Country;
  expiresAt: string;
  password?: string;
}

/**
 * @deprecated Use class instead because there is only one implementation of this interface which makes searching for references
 * more difficult, name shouldn't be prefixed too: https://blog.nette.org/en/prefixes-and-suffixes-do-not-belong-in-interface-names.
 */
export interface IBackendGatewayUsersApiClient {
  /**
   * Creates a demo user in the backend gateway.
   */
  createDemoUser(values: CreateDemoUserDto): Promise<SerializedUser>;
}

export class BackendGatewayUsersApiClient extends BaseApiClient implements IBackendGatewayUsersApiClient {
  constructor(jwt: string) {
    super('enmon-tools/users', BASE_REST_API_URL, jwt);
  }

  public async createDemoUser(values: CreateDemoUserDto): Promise<SerializedUser> {
    try {
      const response = await this.axios.post<SerializedUser>('', values, {
        params: {
          role: UserRole.Demo,
        },
      });
      return response.data;
    } catch (e) {
      if (e instanceof AxiosError && e.response?.status === 412) {
        const response = z
          .object({
            error: z.object({
              details: z.array(formErrorSchema),
            }),
          })
          .parse(e.response.data);
        throw new ValidationFailedError(response.error.details);
      }
      throw e;
    }
  }
}
